import { useEffect } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { authTokenState } from "features/auth/state/authAtoms";
import { CFDHistoryLoadingState, CFDHistoryState } from "features/cfd/state/cfdAtoms";
import { apiRenderKeyState } from "shared/state/renderKeyAtoms";
import { fetchCFDHistory } from "features/cfd/api/fetchCFDHistory";

export const useFetchCFDHistory = () => {
  const setCFDHistoryList = useSetRecoilState(CFDHistoryState);
  const setCFDHistoryLoading = useSetRecoilState(CFDHistoryLoadingState);
  const authToken = useRecoilValue(authTokenState);
  const renderKey = useRecoilValue(apiRenderKeyState);

  // 履歴取得中のアンマウントを考慮してロードする
  useEffect(() => {
    let cancelled = false;

    const loadCFDHistory = async () => {
      if (authToken === '') {
        setCFDHistoryLoading(false);
        return;
      }

      setCFDHistoryLoading(true);
      try {
        const history = await fetchCFDHistory(authToken);
        if (history && !cancelled) setCFDHistoryList(history);
      } finally {
        if (!cancelled) setCFDHistoryLoading(false);
      }
    };

    loadCFDHistory();
    return () => { cancelled = true; };
  }, [authToken, renderKey, setCFDHistoryList, setCFDHistoryLoading]);
};
